export default "__VITE_ASSET__RL5Wi1e1__"